import { useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';

interface ScannerQRProps {
  onScan: (decodedText: string) => void;
  onClose: () => void;
}

export function ScannerQR({ onScan, onClose }: ScannerQRProps) {
  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      "reader",
      { fps: 10, qrbox: { width: 250, height: 250 } },
      /* verbose= */ false
    );

    scanner.render((decodedText) => {
      onScan(decodedText);
      scanner.clear();
      onClose();
    }, () => {
      // ignore
    });

    return () => {
      scanner.clear().catch(err => console.error("Failed to clear scanner", err));
    };
  }, []);

  return (
    <div className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center">
      <div id="reader" className="w-full max-w-md bg-white rounded-2xl overflow-hidden"></div>
      <button 
        onClick={onClose}
        className="mt-8 px-8 py-3 bg-white/10 text-white rounded-full font-bold backdrop-blur-md"
      >
        Cancelar
      </button>
    </div>
  );
}
